<template>
	<BasePopover
		:id="$options.name"
		placement="bottom"
		:status.sync="status"
		:target-id="targetId"
	>
		<template #default>
			{{ $t("Bravo, Sinao est configuré, vous pouvez maintenant éditer votre première facture.") }}
			<br /> <br />

			<s-button type="" @click="onSubmit">
				{{ $t("Super !") }}
			</s-button>
		</template>
	</BasePopover>
</template>

<script>
	import { mapState } from "vuex";
	import { query } from "sinao-corejs";

	export default {
		name: "PopoverEndOnboarding",
		props: {
			targetId: {
				type: String,
				required: true
			}
		},
		computed: {
			...mapState({
				appId: state => state.app.id
			}),
			status: {
				get() {
					return this.$store.state.onboarding
						.showPopoverEndOnboarding;
				},
				set(value) {
					this.$store.commit("showPopoverEndOnboarding", value);
				}
			}
		},
		methods: {
			onSubmit() {
				this.next();
			},
			next() {
				query({
					operationId: "app.settings.update",
					params: {
						appId: this.appId
					},
					data: {
						settings: {
							"installation.onboarding.showPopoverEndOnboarding": 1,
							"installation.profile-onboarding": 1
						}
					}
				});

				this.status = false;
				this.$store.commit("onboarding", false);
        this.$store.commit("setPopovers", { key: "showPopoverEndOnboarding", value: false });
			}
		}
	};
</script>

<style lang="scss"></style>
